import request from "@/utils/request";


export function backApproval (params) {
  return request({
    url: '/wechat/examine/rollback',
    method: 'PUT',
    data: params
  })
}

// 加签接口
export function addSignSubmit (params) {
  return request({
    url: '/wechat/examine/addSign/submit',
    method: 'PUT',
    data: params
  })
}

// 转交接口
export function transferSubmit (params) {
  return request({
    url: '/wechat/examine/handedOver',
    method: 'PUT',
    data: params
  })
}

export function nodeList (data) {
  return request({
    url: `/wechat/examine/nodeList?processInstanceId=${data.processInstanceId}&dataId=${data.dataId}`,
    method: 'GET',
  })
}

// 获取审批列表
export function getApproveList(params) {
  return request({
    url: "/wechat/examine/show/v2.5.7",
    method: "GET",
    params,
  });
}

//用印审批【拒绝】【同意】 v3.0修改
export function approvalSeal(params) {
  return request({
    url: "/wechat/examine/approval/result/upload",
    method: "put",
    data: params,
  });
}

//审批详情 v3.0
export function getApproveDetail(params) {
  return request({
    // url: `/wechat/examine/approval/all/details/${params.documentId}`,
    url: '/wechat/examine/approval/all/details',
    method: "GET",
    params
  });
}

// 获取抄送我的列表
export function copyList(params) {
  return request({
    url: "/wechat/carbonCopy/list/v3.7.0",
    method: "GET",
    params,
  });
}

// 获取电子印章抄送详情
export function getInformSeal(id) {
  return request({
    url: `/wechat/carbonCopy/${id}`,
    method: "GET",
  });
}

// 获取实体印章抄送详情
export function getEntitySeal(params) {
  return request({
    url: `/wechat/carbonCopy/${params.documentId}/${params.sealId}`,
    method: "GET",
  });
}

//v3.0抄送详情
export const getSendDetail = (params) => {
  return request({
    url: `/wechat/carbonCopy/details/${params.documentId}`,
    method: "GET",
    params,
  });
};
//获取待审批列表
export function pendingList(params) {
  return request({
    url: `/wechat/examine/approval/pending/list`,
    method: "GET",
    params,
  });
}
//获取已审批列表
export function approvalList(params) {
  return request({
    url: `/wechat/examine/approval/over/list`,
    method: "GET",
    params,
  });
}
// 获取我发起的审批列表
export function myInitiate(params) {
  return request({
    url: '/wechat/examine/approval/my/list',
    method: 'GET',
    params
  })
}

// 归档前校验
export function isNeedMakeUp(id) {
  return request({
    url: `/wechat/home/isNeedMakeUp/${id}`,
    method: 'GET'
  })
}

//用印信息
export function getDocumentInfo(params) {
  return request({
    url: `/wechat/examine/all/details/documentInfo`,
    method: 'GET',
    params
  })
}
// 图片转换pdf
export function imagesConvertPdf(params) {
  return request({
    url: `/file/imagesConvertPdf/fileId`,
    method: "POST",
    data: params,
  })
}
